










import { Component, Vue } from "vue-property-decorator";

import { SnackbarInterface } from "shared/store/snackbar/state";
import { namespace } from "vuex-class";
import { Appointment, getAll } from "../api";
import AppointmentTable from "../components/AppointmentTable.vue";

const snackStore = namespace("snackbar");

@Component({
  components: { AppointmentTable },
})
export default class MySubscriptions extends Vue {
  @snackStore.Mutation setSnackbar!: (payload: SnackbarInterface) => void;

  appointments: Appointment[] = [];

  mounted(): void {
    getAll()
      .then((res) => (this.appointments = res))
      .catch((): void => {
        this.setSnackbar({
          text: this.$t("global.errors.default").toString(),
          color: "error",
        });
      });
  }
}
